var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-panel',[_c('v-container',[_c('v-card',[_c('v-card-text',{staticClass:"display-2 text-center mt-5 primary white--text"},[_vm._v(" Route Groups ")])],1)],1),_c('route-group-form',{attrs:{"id":_vm.id},on:{"completed":_vm.completed}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }